import React, { memo } from 'react';
import { processInt, processNum, processStr, validateEmail } from '../../global';
import { deepEqual, isNormalInteger, isPositiveFloat } from '../../utils/util';

const Row = ({ index, x, services, destinations, user, autoCN, updateGrid, updateDest, findDuplicates, destRef, codAmountLimit }) => {
    return <tr key={index}>
        <td>{index + 1}</td>
        <td><input style={{ width: 170 }} maxLength={15} id={`Consignment${index + 1}`} className={x.Consignment == '' ? "form-control is-invalid" : "form-control"} defaultValue={x.Consignment} onInput={processNum} onBlur={(e) => updateGrid(index, 'Consignment', e.target.value)} /></td>
        <td><input type="text" style={{ width: 160 }} className={!x.CustomerReferenceNumber || x.CustomerReferenceNumber.trim() === '' ? "form-control is-invalid" : !user.isDuplicateOrderAllowed && findDuplicates(x.CustomerReferenceNumber) ? "form-control is-invalid bulk-text" : "form-control"} id={`CustomerReferenceNumber${index + 1}`} maxLength={200} defaultValue={x.CustomerReferenceNumber} onInput={processStr} onChange={(e) => updateGrid(index, 'CustomerReferenceNumber', e.target.value)} /></td>
        <td><input style={{ width: 200 }} maxLength={50} id={`ICCID${index + 1}`} className={!x.ICCID || x.ICCID.trim() === '' || x.ICCID.length > 49 ? "form-control is-invalid bulk-text" : "form-control"} defaultValue={x.ICCID && x.ICCID.substring(0, 50)} onChange={(e) => updateGrid(index, 'ICCID', e.target.value)} /></td>
    </tr>
}

const MemoRow = memo(Row, (prv, nxt) => {
    return deepEqual(prv.x, nxt.x);
});


export default MemoRow;


